import React from "react";
import PropTypes from "prop-types";

import { Dimmer, Loader } from "semantic-ui-react";

import InfiniteScroll from "components/InfiniteScroll";

import { TemplateCardPlaceholder, TemplatesColumns } from "./components";

export function TemplatesList({ templates }) {
  if (templates.loading && templates.fetchCount === 0) {
    return (
      <Dimmer active inverted style={{ position: "static" }}>
        <Loader content="Loading Templates" data-test="templates-loader" />
      </Dimmer>
    );
  }

  if (!templates.loading && templates.isEmpty) {
    return <span>There are no templates available at the moment</span>;
  }

  return (
    <InfiniteScroll
      loadingPage={templates.loading}
      hasMorePages={templates.hasMorePages}
      onLoadMore={templates.readNext}
      loadingElement={<TemplateCardPlaceholder />}
    >
      <TemplatesColumns
        data={templates.data()}
        disabled={templates.installing || templates.refetching}
      />
    </InfiniteScroll>
  );
}

TemplatesList.propTypes = {
  templates: PropTypes.object.isRequired,
};

TemplatesList.defaultProps = {};

export default TemplatesList;
